import { PathEnum } from '@/types/enums';
import { Pathnames } from 'next-intl/routing';

export const defaultLocale = 'de';
export const locales = [defaultLocale, 'en', 'fr', 'es'] as const;

export const pathnames = {
    ...PathEnum,
} as Pathnames<typeof locales>;

export const localePrefix = 'always';

export type AppPathnames = keyof typeof pathnames;
